import React, { useEffect } from 'react'
import { useParams } from 'react-router'
import Loader from '../../components/Loader'
import { useSalesChannelType } from '../../hooks/CompanyConfiguration/useSalesChannelType'
import AddSalesChannelType from './AddSalesChannelType'

export default function EditSalesChannelType() {
  const { salesChannelType, getSalesChannelType } = useSalesChannelType()
  const params = useParams()
  useEffect(() => {
    getSalesChannelType({ salesChannelTypeId: params.salesChannelTypeId })
  }, [params.salesChannelTypeId])

  return <> {salesChannelType ? <AddSalesChannelType salesChannelType={salesChannelType} /> : <Loader />} </>
}
